module.exports = __webpack_public_path__ + "static/media/create-comment.0beac6a2.svg";